import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { listJetCallReports } from 'api/admin/jet/listJetCallReports'
import { jetKeys } from './keys'

export const useJetCallReportsQuery = (
  request: Parameters<typeof listJetCallReports>[0]
) => {
  return useQuery({
    queryKey: jetKeys.callReportsList(request),
    queryFn: () => listJetCallReports(request),
    placeholderData: keepPreviousData,
  })
}
